import type { PlcManufacturerCodeLibrary } from "./types";

export const siemensCodeLibrary: PlcManufacturerCodeLibrary = {
  manufacturer_id: "siemens",
  manufacturer_name: "Siemens",
  codes: [
    {
      id: "siemens-s7-1200-stop-run-yellow",
      manufacturer_id: "siemens",
      series_id: "siemens-s7-1200",
      model: null,
      code: "STOP/RUN: SOLID YELLOW",
      code_type: "LED",
      title_ar: "S7-1200 بحالة STOP",
      description_ar: "إضاءة STOP/RUN باللون الأصفر الثابت تعني أن CPU مال S7-1200 بحالة STOP.",
      symptoms: ["البرنامج ما ينفذ", "STOP/RUN أصفر ثابت"],
      causes: ["الـCPU متوقف بأمر تشغيل", "أكو سبب تشخيصي مخلي الـCPU يبقى STOP"],
      checks: [
        {
          step: 1,
          action: "افتح Online & Diagnostics بـTIA Portal واقرأ حالة الـCPU والـDiagnostic Buffer.",
          expected: "سبب الـSTOP يكون واضح أو ماكو Fault مانع RUN.",
          faulty: "أكو Diagnostic Event أو Fault يمنع الانتقال إلى RUN.",
        }
      ],
      solutions: ["عالج أول Diagnostic Event ظاهر قبل محاولة RUN.", "لا تمسح الـdiagnostics قبل تسجيل سبب التوقف."],
      severity: "تحذير",
      source_title: "Siemens SIMATIC S7-1200 Programmable Controller",
      source_section: "Status LEDs on a CPU: STOP/RUN solid yellow = STOP mode",
      keywords: ["Siemens", "S7-1200", "STOP", "RUN", "LED"],
    },
    {
      id: "siemens-s7-1200-stop-run-green",
      manufacturer_id: "siemens",
      series_id: "siemens-s7-1200",
      model: null,
      code: "STOP/RUN: SOLID GREEN",
      code_type: "LED",
      title_ar: "S7-1200 بحالة RUN",
      description_ar: "إضاءة STOP/RUN باللون الأخضر الثابت تعني أن CPU مال S7-1200 بحالة RUN.",
      symptoms: ["البرنامج ينفذ", "STOP/RUN أخضر ثابت"],
      causes: ["هذه حالة تشغيل طبيعية"],
      checks: [
        {
          step: 1,
          action: "قارن حالة الـLED ويا حالة CPU Online بـTIA Portal.",
          expected: "الحالتين يبينن RUN.",
          faulty: "إذا TIA يبين حالة مختلفة، افحص الاتصال والـdiagnostics.",
        }
      ],
      solutions: ["ما يحتاج إجراء إذا المنظومة تشتغل طبيعي.", "إذا العملية متوقفة رغم RUN، انتقل لفحص البرنامج والـI/O والـinterlocks."],
      severity: "معلومة",
      source_title: "Siemens SIMATIC S7-1200 Programmable Controller",
      source_section: "Status LEDs on a CPU: STOP/RUN solid green = RUN mode",
      keywords: ["Siemens", "S7-1200", "RUN", "LED"],
    },
    {
      id: "siemens-s7-1200-error-flashing-red",
      manufacturer_id: "siemens",
      series_id: "siemens-s7-1200",
      model: null,
      code: "ERROR: FLASHING RED",
      code_type: "LED",
      title_ar: "S7-1200 بيه خطأ تشخيصي",
      description_ar: "وميض ERROR بالأحمر يدل على خطأ مثل خطأ داخلي بالـCPU أو Memory Card أو Configuration غير مطابق.",
      symptoms: ["ERROR يومض أحمر", "ممكن CPU يبقى STOP أو يظهر Diagnostic Event"],
      causes: ["Internal CPU error", "Memory Card error", "Configuration mismatch"],
      checks: [
        {
          step: 1,
          action: "اقرأ Diagnostic Buffer بـTIA Portal.",
          expected: "يظهر الحدث الأصلي بالتشخيص.",
          faulty: "ما تكتفي بالـLED بدون قراءة التشخيص.",
        }
      ],
      solutions: ["عالج السبب المحدد بالـDiagnostic Buffer.", "إذا المشكلة Configuration، قارن الموديولات الفعلية ويا Hardware Configuration."],
      severity: "عالية",
      source_title: "Siemens SIMATIC S7-1200 Programmable Controller",
      source_section: "Status LEDs: ERROR flashing red",
      keywords: ["Siemens", "S7-1200", "ERROR", "flashing red", "memory card", "configuration"],
    },
    {
      id: "siemens-s7-300-sf-red",
      manufacturer_id: "siemens",
      series_id: "siemens-s7-300",
      model: null,
      code: "SF: RED",
      code_type: "LED",
      title_ar: "S7-300 System Fault",
      description_ar: "إضاءة SF بالأحمر في S7-300 تدل على Hardware fault أو Software error.",
      symptoms: ["SF أحمر", "الـCPU أو المنظومة بيها تشخيص خطأ"],
      causes: ["Hardware fault", "Software error"],
      checks: [
        {
          step: 1,
          action: "اقرأ Diagnostic Buffer ببرنامج STEP 7 المناسب.",
          expected: "يظهر مصدر الـSF بالتفصيل.",
          faulty: "يبقى SF بدون معالجة السبب.",
        }
      ],
      solutions: ["عالج أول حدث تشخيصي.", "افحص الموديولات والبرنامج حسب الحدث المسجل."],
      severity: "عالية",
      source_title: "Siemens S7-300 CPU 31xC / CPU 31x",
      source_section: "Status and error indicators: SF red = hardware fault or software error",
      keywords: ["Siemens", "S7-300", "SF", "system fault"],
    },
    {
      id: "siemens-s7-300-bf-red",
      manufacturer_id: "siemens",
      series_id: "siemens-s7-300",
      model: null,
      code: "BF: RED",
      code_type: "LED",
      title_ar: "S7-300 Bus Fault",
      description_ar: "إضاءة BF بالأحمر تدل على خطأ Bus بالواجهة المرتبطة.",
      symptoms: ["BF أحمر", "فقدان اتصال ويا أجهزة الشبكة أو الـremote I/O"],
      causes: ["Bus communication fault", "Station/device not reachable", "إعداد شبكة مو مطابق"],
      checks: [
        {
          step: 1,
          action: "حدد أي BF/واجهة متأثرة واقرأ Hardware Diagnostics.",
          expected: "كل الأجهزة المطلوبة Online.",
          faulty: "جهاز أو محطة تظهر Offline أو Bus Fault.",
        }
      ],
      solutions: ["افحص الكيبل والعناوين والتغذية للأجهزة البعيدة.", "قارن إعداد الشبكة ويا الأجهزة الفعلية."],
      severity: "عالية",
      source_title: "Siemens S7-300 CPU 31xC / CPU 31x",
      source_section: "Status and error indicators: BF red = bus error",
      keywords: ["Siemens", "S7-300", "BF", "bus fault", "PROFIBUS", "PROFINET"],
    },  ],
};
